exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination-wrap[data-v-a04bb986] {\n  text-align: right;\n  padding: 30px 20px;\n}\n", ""]);

// exports
